module.exports = __webpack_public_path__ + "img/mena-hawk.e94abccc.svg";